/*
 * Barra com cronometro (sections/custom-barra-countdown.liquid)
 * Custom element independente: nao usa jQuery nem slick.
 * Os numeros ja vem renderizados pelo Liquid; aqui so corrigimos e tickamos.
 */
(function () {
  'use strict';

  if (!window.customElements || customElements.get('ph-countdown-bar')) return;

  const STORAGE_PREFIX = 'phcd:';

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function now() {
    return Math.floor(Date.now() / 1000);
  }

  function readStore(key) {
    try {
      return window.localStorage.getItem(STORAGE_PREFIX + key);
    } catch (e) {
      return null;
    }
  }

  function writeStore(key, value) {
    try {
      window.localStorage.setItem(STORAGE_PREFIX + key, value);
    } catch (e) {
      /* modo privado / storage bloqueado: segue sem persistir */
    }
  }

  class PhCountdownBar extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId || 'default';
      this.mode = this.dataset.mode || 'date';
      this.showDays = this.dataset.showDays === 'true';
      this.expireAction = this.dataset.expireAction || 'hide';
      this.designMode = this.dataset.designMode === 'true';

      this.closeDays = parseInt(this.dataset.closeDays, 10);
      if (isNaN(this.closeDays)) this.closeDays = 1;

      this.timerEl = this.querySelector('[data-phcd-timer]');
      this.expiredEl = this.querySelector('[data-phcd-expired]');
      this.values = {
        days: this.querySelector('[data-phcd-value="days"]'),
        hours: this.querySelector('[data-phcd-value="hours"]'),
        minutes: this.querySelector('[data-phcd-value="minutes"]'),
        seconds: this.querySelector('[data-phcd-value="seconds"]')
      };

      if (this.isDismissed()) {
        this.hidden = true;
        return;
      }

      const closeBtn = this.querySelector('[data-phcd-close]');
      if (closeBtn) closeBtn.addEventListener('click', this.dismiss.bind(this));

      this.target = this.resolveTarget();
      if (!this.target) return;

      this.tick();
      this.interval = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    /* Data fixa vem do Liquid em epoch; o modo recorrente guarda o alvo por visitante. */
    resolveTarget() {
      if (this.mode === 'evergreen') {
        let hours = parseFloat(this.dataset.evergreenHours);
        if (!hours || hours <= 0) hours = 24;

        const key = 'evergreen:' + this.sectionId + ':' + hours;
        let stored = parseInt(readStore(key), 10);

        if (!stored || isNaN(stored) || stored <= now()) {
          stored = now() + Math.round(hours * 3600);
          writeStore(key, String(stored));
        }
        return stored;
      }

      const end = parseInt(this.dataset.end, 10);
      return !end || isNaN(end) ? 0 : end;
    }

    tick() {
      const remaining = this.target - now();

      if (remaining <= 0) {
        this.render(0);
        this.expire();
        return;
      }

      this.render(remaining);
    }

    render(remaining) {
      const days = this.showDays ? Math.floor(remaining / 86400) : 0;
      const hours = this.showDays
        ? Math.floor((remaining % 86400) / 3600)
        : Math.floor(remaining / 3600);

      this.write('days', days);
      this.write('hours', hours);
      this.write('minutes', Math.floor((remaining % 3600) / 60));
      this.write('seconds', remaining % 60);
    }

    write(unit, value) {
      const el = this.values[unit];
      if (!el) return;

      const text = pad(value);
      if (el.textContent !== text) el.textContent = text;
    }

    expire() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }

      /* No editor de temas a barra nunca some, senao o lojista perde a secao de vista. */
      if (this.designMode) return;

      if (this.expireAction === 'hide') {
        this.hidden = true;
        return;
      }

      if (this.expireAction === 'message' && this.expiredEl) {
        if (this.timerEl) this.timerEl.hidden = true;
        this.expiredEl.hidden = false;
      }
    }

    dismissKey() {
      return 'closed:' + this.sectionId;
    }

    isDismissed() {
      if (this.designMode) return false;

      const until = parseInt(readStore(this.dismissKey()), 10);
      return !!until && !isNaN(until) && until > now();
    }

    dismiss(event) {
      if (event) event.preventDefault();

      this.hidden = true;
      if (this.interval) clearInterval(this.interval);

      if (this.closeDays > 0) {
        writeStore(this.dismissKey(), String(now() + this.closeDays * 86400));
      }
    }
  }

  customElements.define('ph-countdown-bar', PhCountdownBar);
})();
